import { Check } from "lucide-react";
import { ParceirosV2HeroForm } from "@/components/parceiros-v2/ParceirosV2HeroForm";

const BULLETS = [
  "Processo simples e rápido",
  "Suporte dedicado para parceiros",
  "Treinamento completo sobre o produto",
];

export const AssessoresFormSection = () => {
  return (
    <section className="bg-[#FAF8F5] py-16 sm:py-20 md:py-24">
      <div className="container-wide px-6 sm:px-6 md:px-12">
        <div className="grid lg:grid-cols-12 gap-10 lg:gap-16 items-start">
          <div className="lg:col-span-6">
            <span className="inline-flex items-center rounded-full bg-[#34F285]/[0.06] px-4 py-1.5 text-xs font-medium text-[#1F3D2E] ring-1 ring-[#1F3D2E]/10">
              Faça parte
            </span>
            <h2
              className="mt-6 font-extrabold leading-[1.1] tracking-tight text-[#323F4F] text-3xl sm:text-4xl md:text-5xl"
              style={{ fontFamily: '"Plus Jakarta Sans", Inter, system-ui, sans-serif' }}
            >
              Torne-se um parceiro da Allu.
            </h2>
            <p className="mt-5 text-base sm:text-lg text-zinc-600 leading-relaxed max-w-md">
              Preencha o formulário e nossa equipe entra em contato para
              apresentar a parceria em detalhes.
            </p>

            <ul className="mt-8 space-y-3">
              {BULLETS.map((b) => (
                <li key={b} className="flex items-center gap-3">
                  <span className="flex-shrink-0 w-5 h-5 rounded-full bg-[#34F285]/[0.1] flex items-center justify-center">
                    <Check className="w-3 h-3 text-[#2E694D]" />
                  </span>
                  <span className="text-sm sm:text-base text-[#323F4F]">
                    {b}
                  </span>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-6">
            <ParceirosV2HeroForm />
          </div>
        </div>
      </div>
    </section>
  );
};
